module.exports = __webpack_public_path__ + "img/SURVEY_DEPRESSIONSCALE.264f5c8c.png";